import React from "react";
import "./Partners.css";

function Partners() {
  return (
    <div className="partner" id="partners">
      <h1>Our Partners</h1>
      <div className="container">
        <div className="partner-image">
          <div>
            <img src="../../img/partner1.jpg" alt="" />
          </div>
          <div>
            {" "}
            <img src="../../img/partner2.jpg" alt="" />
          </div>
          <div>
            <img src="../../img/partner3.jpg" alt="" />
          </div>
          <div>
            <img src="../../img/partner4.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
